// extracted by mini-css-extract-plugin
module.exports = {"link_container":"legal-footer_link_container__Kbb5r","footer":"legal-footer_footer__b8_Uz","link":"legal-footer_link__CRKdf","copyright":"legal-footer_copyright__VW6zA"};